import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import arrowDown from '../../../../assets/images/common/arrow-down-b.svg';

type Props = {
  goToPlan: (plan: any) => void;
  setPlansMenuOpen: (isOpen: boolean) => void;
  savedPlans: any;
  weeklyPlans: any;
  title: string;
};

const PlansDropDown = (props: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [weeklyPlans, setWeeklyPlans] = useState([]);
  const [savedPLans, setSavedPLans] = useState([]);

  useEffect(() => {
    isOpen && window.addEventListener('click', clickHandler);
    return () => {
      window.removeEventListener('click', clickHandler);
    };
  }, [isOpen]);

  const clickHandler = (e) => {
    const dropDownMenuDocument = document.getElementById('plan-drop-down');
    if (dropDownMenuDocument !== e.target.parentElement) {
      props.setPlansMenuOpen(false)
      setIsOpen(false);
    }
  };
  useEffect(() => {
    setSavedPLans(props.savedPlans);
    setWeeklyPlans(props.weeklyPlans);
  }, [props.savedPlans, props.weeklyPlans]);

  const toggle = () => {
    props.setPlansMenuOpen(!isOpen)
    setIsOpen(!isOpen);
  };

  const goToPlan = (plan) => {
    props.setPlansMenuOpen(false)
    setIsOpen(false);
    return props.goToPlan(plan);
  };
  return (
    <div className='plan'>
      <div className='plan-block' onClick={toggle}>
        <div className='title'>{props.title}</div>
        <img className='arrow' src={arrowDown} alt='arrow' />
      </div>
      <div id='plan-drop-down' className={cx('plan-menu', { visible: isOpen })}>
        <div className='group-title'>Weekly Plans</div>
        {weeklyPlans.map((plan) => (
          <button key={plan.dateSlug} onClick={() => goToPlan(plan)}>
            <div className='plan-title'>{plan.title}</div>
          </button>
        ))}
        <div className='group-title'>Saved Plans</div>
        {savedPLans.map((plan) => (
          <button key={plan.nameSlug} onClick={() => goToPlan(plan)}>
            <div className='plan-title'>{plan.name}</div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default PlansDropDown;
